<i18n>
{
  "fr": {
    "hours-interval": "{start} - {end}",
    "hours-acc": " et ",
    "hours-closed": "Fermé",
    "button-show": "Consulter les horaires",
    "button-hide": "Fermer les horaires"
  }
}
</i18n>

<template>
  <div class="relay-opening-hours">
    <ol v-show="showHours" class="relay-opening-hours__days-hours-list">
      <li
        v-for="(day, index) in dayMapping"
        :key="index"
        class="relay-opening-hours__day-hours"
      >
        <span class="relay-opening-hours__day">
          {{ day }}
        </span>

        <template v-if="data[index + 1]">
          <span v-for="(hour, key) in data[index + 1]" :key="hour.START_TM">
            <span v-if="key !== 0"> {{ $t('hours-acc') }} </span>
            {{
              $t('hours-interval', {
                start: hour.START_TM,
                end: hour.END_TM,
              })
            }}
          </span>
        </template>

        <span v-else>{{ $t('hours-closed') }}</span>
      </li>
    </ol>

    <button
      type="button"
      class="base-btn base-btn--link relay-opening-hours__button"
      @click="toggleHoursDisplay"
    >
      {{ $t(showHours ? 'button-hide' : 'button-show') }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'RelayOpeningHours',
  props: {
    data: {
      type: Object,
      required: true,
    },
    hoursVisible: Boolean,
  },
  data() {
    return {
      value: this.active,
      showHours: this.hoursVisible,
      dayMapping: [
        'Lundi',
        'Mardi',
        'Mercredi',
        'Jeudi',
        'Vendredi',
        'Samedi',
        'Dimanche',
      ],
    };
  },
  methods: {
    toggleHoursDisplay() {
      this.showHours = !this.showHours;
    },
  },
};
</script>
